import SharedToolbar, { type SharedToolbarProps } from "../SharedToolbar";

export type { ColumnDetails, ColumnDetailsMap, ColumnLabel } from "../toolbarTypes";

type Props = Omit<SharedToolbarProps, "createLabelKey">;

const Toolbar = (props: Props) => <SharedToolbar {...props} createLabelKey="recipe.toolbar.newRecipe" />;

export default Toolbar;
